<footer class="desktop-footer">
  <ng-content></ng-content>
</footer>
